'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.profile = profile;
exports.profileIntervalBegin = profileIntervalBegin;
exports.profileIntervalEnd = profileIntervalEnd;
exports.profileIntervalFail = profileIntervalFail;
// profile for static event
function profile(message) {
    if (isClientProfilerEnabled()) {
        window.ClientProfiler.profile(message);
    }
}

// profile for dynamic event, triggered a start
function profileIntervalBegin(message) {
    if (isClientProfilerEnabled()) {
        window.ClientProfiler.profileIntervalBegin(message);
    }
}

// profile for dynamic event, triggered an end
function profileIntervalEnd(message) {
    if (isClientProfilerEnabled()) {
        window.ClientProfiler.profileIntervalEnd(message);
    }
}

// profile for dynamic event, triggered a fail
function profileIntervalFail(message) {
    if (isClientProfilerEnabled()) {
        window.ClientProfiler.profileIntervalFail(message);
    }
}

function isClientProfilerEnabled() {
    return typeof window !== 'undefined' && !!window.ClientProfiler;
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler/dist/index.js
// module id = 500
// module chunks = 0